import { render, staticRenderFns } from "./EntregaDocumentosOriginales.vue?vue&type=template&id=3bff6260"
import script from "./EntregaDocumentosOriginales.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentosOriginales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bff6260')) {
      api.createRecord('3bff6260', component.options)
    } else {
      api.reload('3bff6260', component.options)
    }
    module.hot.accept("./EntregaDocumentosOriginales.vue?vue&type=template&id=3bff6260", function () {
      api.rerender('3bff6260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/staff/EntregaDocumentosOriginales.vue"
export default component.exports